<template>
  <div>
    <b-sidebar
      id="viewinvoice"
      width="60vw"
      :title="invoice ? invoice.refNumber : 'Invoice'"
      lazy backdrop shadow
    >
      <Invoice v-if="invoice" no-edit :item="invoice" @click.prevent />
      <div v-else>
        Invoice not loaded
      </div>
    </b-sidebar>

    <b-button-toolbar class="float-right perpage" key-nav>
      <div right>
        <b-button-group>
          <b-button size="sm" variant="outline-primary" @click="$refs.top.selectAllRows()">
            Select all
          </b-button>
          <b-button size="sm" variant="outline-primary" @click="$refs.top.clearSelected()">
            Clear selected
          </b-button>
        </b-button-group>
      </div>
    </b-button-toolbar>

    <b-table
      ref="top" hover small caption-top responsive empty-html="No items to show"
      :fields="fields"
      :items="invoices"
      :borderless="true" bvwsdwefvt striped
      show-empty
      :selectable="true"
      select-mode="multi"
      @row-selected="onRowSelected"
    >
      <template v-slot:cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <fa-icon :icon="['far', 'check-square']" />
        </template>
        <template v-else>
          <fa-icon :icon="['far', 'square']" />
        </template>
      </template>

      <template v-slot:cell(ref)="{ item }">
        <b-badge variant="primary">
          {{ item.refNumber }}
        </b-badge>
      </template>
      <template v-slot:cell(view)="{ item }">
        <a href="#" @click.prevent="invoice = item.invoiceData"><span v-b-toggle.viewinvoice><fa-icon icon="file-alt" /> view</span></a>
      </template>
      <template v-slot:cell(period)="{ item }">
        {{ item.startDate | moment('L') }} - {{ item.endDate | moment('L') }}<br>
      </template>
      <template v-slot:cell(status)="{ item }">
        <b-badge :variant="item.status === 'CONFIRMED' ? 'warning' : 'danger'">
          {{ item.status }}
        </b-badge>
      </template>
      <template v-slot:cell(invoice)="{ item }">
        <InvoiceInfo v-if="item" :invoice-id="item.id" @invoice="(data) => item.invoiceData = data" />
      </template>
      <template v-slot:cell(latestjob)="{ item }">
        <InvoiceLatestJobOutput v-if="item" :invoice-id="item.id" />
      </template>
    </b-table>
  </div>
</template>


<script>
import InvoiceInfo from './periodic-wizard-invoice-info.vue';
import InvoiceLatestJobOutput from './invoice-latest-job-output.vue';
import Invoice from './invoice.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

library.add(faFileAlt);

export default {
  components: {
    InvoiceInfo,
    Invoice,
    InvoiceLatestJobOutput
  },
  props: ['wizardId', 'date'],
  data () {
    return {
      invoices: [],
      invoice: null,
      fields: [
        {
          key: 'selected',
          label: '',
          sortable: false,
        },
        {
          key: 'ref',
          label: 'Invoice nr',
          sortable: false,
        },
        {
          key: 'period',
          label: 'Period',
          sortable: false,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false,
        },
        {
          key: 'invoice',
          label: 'Invoice',
          sortable: false,
        },
        {
          key: 'view',
          label: 'View',
          sortable: false,
        },
        {
          key: 'latestjob',
          label: 'Latest Job output',
          sortable: false,
        }
      ]
    };
  },
  created () {
    const params = {
      where: {
        wizardId: this.wizardId
      }
    };
    this.$http.get(`/invoices`, { params })
      .then(({ data }) => {
        this.invoices = data;
      })
      .catch(err => this.err(err));
  },
  methods: {
    err (err) {
      this.error('Error', err.response && err.response.data ? err.response.data.message || err.message : err.message);
      this.errors = err.response && err.response.data ? err.response.data.details || {} : {};
      throw err;
    },
    error (title, msg) {
      this.$notify({
        title,
        text: msg,
        type: 'error',
      });
    },
    onRowSelected (items) {
      this.$emit('selected', items);
    }
  },

};
</script>
